export const ALLOWED_MINUTES_FOR_PROCESSING = 10
export const POLLING_INTERVAL = 3000
export const PAGINATION_LIMIT = 10
export const POLLING_STATUS = 6
export const PAGE_SIZE = 50
export const QUOTE_MODEL = 'QuoteModel'
export const QUOTE_MODEL_REVISION = 'QuoteModelRevision'
export const QUOTE_ATTACHMENT = 'QuoteAttachment'
export const QUOTE_MODEL_REVISION_ATTACHMENT = 'QuoteModelRevisionAttachment'
export const USER_ENTERED_MATERIAL = 'UserEnteredMaterial'
export const MOLDABLE_IM_SCORE_MIN = 0.5
export const MODEL_PREFIX = 'model:'
export const ATTACHMENT_PREFIX = 'attachment:'
export const DETAILS_TABLE_ROW = 'details-table-row'
export const MOLD_DETAILS_TABLE_ROW = 'mold-details-table-row'
export const ROW_ACTIONS_MENU = 'details-table-row-actions'
export const TOOLS = {
    addToQuote: 'add-to-quote',
    uploadModels: 'upload-models',
    remove: 'remove',
}
export const PDF_OCR_ANALYSIS_TIMEOUT_MINUTES = 2
export const RELEASE_AUTO_ATTACH_DRAWINGS = 'RELEASE_AUTO_ATTACH_DRAWINGS'
export const AUTO_ATTACH_DRAWINGS_BUTTON_PLACEMENT = 'quote-table-header'
export const MULTIPLE_LEAD_TIME_WARNING_HEADER_IM =
    'Heads up! You have multiple lead-times in this quote.'
export const MULTIPLE_LEAD_TIME_WARNING_MSG_IM =
    'All parts in your quote will be shipped and delivered together based on the longest lead-time. To receive parts as they are ready, select parts of the same lead-time and click “Move to…” to group them into a new quote.'
export const MULTIPLE_LEAD_TIME_WARNING_MSG_GENERIC_TIP =
    'Tip: Need certain parts faster? Find out how to move slower parts to a new quote to optimize lead time.'
export const MULTIPLE_LEAD_TIME_WARNING_MSG_INFO =
    'All parts will ship together based on the part with the longest lead time unless you move that part to a different quote.'
export const QUOTE_PURCHASED_MSG = 'This quote was purchased'

export const REFRESH_MESSAGE_QUOTE =
    'Please try to refresh the page. If the issue persists, you may not have permission to view this quote.'

export const UNABLE_DISPLAY_MESSAGE_QUOTE = "We're unable to display this quote"

export const UNABLE_DISPLAY_MESSAGE_ORDER = "We're unable to display this order"

export const LEARN_MORE = 'Learn more'

export const RETURN_TO_QUOTES = 'Return to My Quotes'

export const RETURN_TO_ORDERS = 'Return to My Orders'

export const PLACEMENT = 'quote-not-found'

export const REFRESH_MESSAGE_ORDER =
    'Please try to refresh the page. If the issue persists, you may not have permission to view this order.'

export const BACK_TO_QUOTES = 'Save and back to all quotes'
export const SAVE_N_EXIT_OPT_MODE = 'Save and exit Lead Time Optimizer'

export const REQUEST_CHANGE_CHECKBOX_OPTIONS = [
    { label: 'Design change (new revision)', value: 'designChange' },
    { label: 'Quantity change', value: 'quantityChange' },
    { label: 'Configuration change', value: 'configurationChange' },
    { label: 'Other (describe below)', value: 'otherChange' },
]

export const TEST_REORDER_ORDER_NAME = 'Test1234' // API's not returning correctly yet, returns null
